import React, { useContext, useState, useEffect, useMemo } from 'react';
import { fetchData } from '../service/data.service';

const FooterContext = React.createContext();

export const useFooterContext = () => useContext(FooterContext);

export function FooterProvider({ children }) {
  const [footerData, setFooterData] = useState({});

  useEffect(() => {
    fetchData
      .get('https://run.mocky.io/v3/0f33a0bb-91b1-46f9-9577-0818118936a9')
      .then(setFooterData);
  }, []);

  const value = useMemo(
    () => ({
      footerData,
    }),
    [footerData]
  );

  return <FooterContext.Provider value={value}>{children}</FooterContext.Provider>;
}
